import type { HierarchyTrailItem } from '../types';

export function getCurrentTrailItem(trail: HierarchyTrailItem[]): HierarchyTrailItem | null {
  return trail.find((item) => item.isCurrent) ?? null;
}
